"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Gabe Kelley, Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=3608%3A749))
 * @trackcomponent
 * @lastsynced 2025-04-16T17:02:15.546Z
 * @optimized using svgo:^3.0.2
 */
export const Finance = createSVGIcon(
  <path
    d="M22.001 9.323H1.998c-.947 0-1.353-1.043-.609-1.539l10.002-6.616a1.19 1.19 0 0 1 1.218 0l10.002 6.616c.744.496.338 1.539-.61 1.539ZM22.154 18.726H1.846c-.224 0-.44.09-.598.25a.86.86 0 0 0-.248.605v2.564c0 .227.09.444.248.605.159.16.374.25.598.25h20.308c.224 0 .44-.09.598-.25a.86.86 0 0 0 .248-.605v-2.564a.86.86 0 0 0-.248-.605.84.84 0 0 0-.598-.25ZM3.539 9.323v9.403M9.18 9.323v9.403M14.82 9.323v9.403M20.461 9.323v9.403"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Finance",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
